module.exports = __webpack_public_path__ + "static/img/419.0e939de1.jpg";